export const getTargetNodeByParentNodeByClassName = (parentNode, className) => {
  let target;
  parentNode.forEach((node) => {
    if (node.className.indexOf(className) > -1) target = node;
  });
  return target;
};
